import { Component, h, Prop, Host, Element, State } from '@stencil/core';

@Component({
    tag: 'sew-ws-teaser-item',
    styleUrl: 'sew-ws-teaser-item.scss',
    shadow: true,
})
export class SewWsTeaserItem {
    @Element() host: HTMLSewWsTeaserItemElement;
    @Prop() headline: string;
    @Prop() text: string;
    @Prop() video = false;
    @State() hasButton = false;

    private triggerContentLink = () => {
        if (!this.hasButton) return;

        const link = this.host.querySelector('a, button') as HTMLElement;

        link.click();
    };

    componentWillLoad(): void {
        this.hasButton = !!this.host.querySelector('[slot="button"]');
    }

    render() {
        return (
            <Host class={{ 'no-button': !this.hasButton }}>
                <div class="image-wrapper" onClick={this.triggerContentLink}>
                    <slot name="picture"></slot>
                    {this.video && (
                        <div class="video">
                            <sew-icon icon="play-filled" size="xl"></sew-icon>
                        </div>
                    )}
                </div>
                <h3 class="headline" innerHTML={this.headline}></h3>
                <p class="text" innerHTML={this.text}></p>
                <slot name="button"></slot>
            </Host>
        );
    }
}
